import netcoServer from '../../apis/netcoServer';
import {INFO_SHOW} from "../types";
import handleResponse from "../helpers/handleResponse";
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";
import loadingCall from "../helpers/loadingCall";
import signed_files from "../../const/signed_files";

const generateTicket = (uid) => async (dispatch, getState) => {
  const formData = {uid: uid, timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone};
  const response = await loadingCall(dispatch, () => netcoServer.newPost('/VerifyService/generateTicket', formData));
  handleResponse(dispatch, response, INFO_SHOW, () =>
    infoPayload('success', signed_files[getState().auth.language].ticketGenerated));
  if (response && response.data && response.data.success)
    handleBase64ZipResponse(response.data.base64File, response.data.fileName ? response.data.fileName : 'ticket.pdf');
};
export default generateTicket;
